/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAwaitingLegacyReposCountQueryVariables = Types.Exact<{ [key: string]: never }>;

export type IAwaitingLegacyReposCountQuery = {
  __typename?: 'Query';
  legacyRepos: { __typename?: 'LegacyRepoPage'; count: number };
};

export const AwaitingLegacyReposCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'awaitingLegacyReposCount' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'legacyRepos' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'statusFilter' },
                value: { kind: 'EnumValue', value: 'awaiting' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', alias: { kind: 'Name', value: 'count' }, name: { kind: 'Name', value: 'nodesCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAwaitingLegacyReposCountQuery, IAwaitingLegacyReposCountQueryVariables>;
